import update from 'immutability-helper';
import { createReducer } from '../../utils/redux/reducers.utils';
import {
  APPLICATION_WIPE_DATA,
  INITIAL_STATE,
  WORKSPACES_RESTRICT_WORKSPACE,
  WORKSPACES_SELECT_WORKSPACE,
  WORKSPACES_UPDATE_CONTENT,
  WORKSPACES_USE_CACHE,
} from '../actions';

const initialState = {
  list: [],
  selected: null,
  lastUpdated: null,
  isReady: false,
};

// A boot-time token refresh can fetch the list before storage hydration lands;
// the persisted copy is older than that response, so never let it win.
const setInitialState = (state, { workspace = initialState }) =>
  state.isReady
    ? state
    : update(state, {
        $merge: {
          ...workspace,
          isReady: false,
        },
      });

const updateWorkspaces = (state, { workspaces }) =>
  update(state, {
    $merge: {
      list: workspaces,
      lastUpdated: Date.now(),
      isReady: true,
    },
  });

const useCache = state =>
  update(state, {
    isReady: { $set: true },
  });

const selectWorkspace = (state, { selected }) =>
  update(state, {
    $merge: {
      selected: selected,
    },
  });

const restrictWorkspace = (state, { workspaceId, restricted }) =>
  update(state, {
    $merge: {
      list: state.list.map(workspace =>
        workspace.id === workspaceId ? { ...workspace, restricted } : workspace,
      ),
      lastUpdated: Date.now(),
    },
  });

const cleanData = () => initialState;

const actionsRepo = {
  [INITIAL_STATE]: setInitialState,
  [WORKSPACES_UPDATE_CONTENT]: updateWorkspaces,
  [WORKSPACES_USE_CACHE]: useCache,
  [WORKSPACES_SELECT_WORKSPACE]: selectWorkspace,
  [WORKSPACES_RESTRICT_WORKSPACE]: restrictWorkspace,
  [APPLICATION_WIPE_DATA]: cleanData,
};

export default createReducer({ initialState, actionsRepo });
